import { Input, Label } from "reactstrap";
import { H6, P, Progressbar, SVG } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { recentActivitiesBodyData } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";

const RecentTradingActivitiesBody = () => {
  return (
    <tbody>
      {recentActivitiesBodyData.map((data, i) => (
        <tr key={i}>
          <td>
            <div className="form-check">
              <Input type="checkbox"/>
              <Label className="form-check-label" />
            </div>
          </td>
          <td>
            <div className="d-flex gap-2">
              <div className="flex-shrink-0">
                <SVG className="animation" iconId={data.icon} />
              </div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/email/letterbox`}>
                  <H6 className="f-w-600">{data.name}</H6>
                  <P>{data.productType}</P>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <H6 className="f-w-600">{data.date}</H6>
            <P>{data.time}</P>
          </td>
          <td>
            <div className="d-flex gap-2">
              <P className="m-0">{data.id}</P>
              <Progressbar value={data.status} color={data.color} />
            </div>
          </td>
          <td>
            <H6 className="f-w-600">{data.volume}</H6>
            <P>{data.usd}</P>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default RecentTradingActivitiesBody;
